import clsx from 'clsx';
import * as styles from './checkbox.module.css';

type CheckboxValue = string | number;
type CheckboxProps = {
    value?: CheckboxValue,
    handleChange: (value?: Partial<CheckboxValue>) => void,
    name?: string,
    label?: string,
    checked?: boolean | undefined,
    defaultChecked?: boolean,
    isRadio?: boolean,
    disabled?: boolean,
    className?: string,
};

const Checkbox = ({
    name,
    label,
    value,
    checked = undefined,
    defaultChecked,
    handleChange,
    isRadio = false,
    disabled = false,
    className,
}: CheckboxProps) => {
    const handleCheckboxChange = () => {
        handleChange(value);
    };

    return (
        <label
            className={clsx(
                styles.checkbox,
                disabled && styles.disabled,
                className,
            )}
        >
            <input
                name={name}
                type={isRadio ? 'radio' : 'checkbox'}
                checked={checked || (!!defaultChecked)}
                onChange={handleCheckboxChange}
                disabled={disabled}
            />
            <div className={styles.checkmark}/>
            {label && (
                <span className={styles.label}>
                    {label}
                </span>
            )}
        </label>
    );
};

export default Checkbox;
